import React from 'react';
import HabitCard from './HabitCard';
import { getToday, getDayOfWeek } from '../utils/dates';

export default function DailyChecklist({ habits, todayCheckins, onCheckin, onUndo }) {
  // Derive the weekday from the same local date string used for the check-in map
  // so the two never disagree around a midnight/timezone boundary.
  const today = getDayOfWeek(getToday());

  // Filter to habits scheduled for today
  const todaysHabits = habits.filter((h) => {
    if (!h.targetDays || h.targetDays.length === 0) return true;
    return h.targetDays.includes(today);
  });

  const done = todaysHabits.filter((h) => todayCheckins[h.habitId]);
  const todo = todaysHabits.filter((h) => !todayCheckins[h.habitId]);
  const totalToday = todaysHabits.length;
  const completedToday = done.length;
  const progress = totalToday > 0 ? (completedToday / totalToday) * 100 : 0;

  return (
    <div>
      {/* Progress bar */}
      {totalToday > 0 && (
        <div className="mb-4">
          <div className="flex justify-between items-center mb-1.5">
            <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
              Today's Progress
            </span>
            <span className="text-sm text-gray-500 dark:text-gray-400">
              {completedToday}/{totalToday}
            </span>
          </div>
          <div className="h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
            <div
              className="h-full bg-primary-600 rounded-full transition-all duration-500"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
      )}

      {/* To do */}
      {todo.length > 0 && (
        <div className="space-y-2 mb-4">
          {todo.map((habit) => (
            <HabitCard
              key={habit.habitId}
              habit={habit}
              isCheckedIn={false}
              onCheckin={onCheckin}
              onUndo={onUndo}
            />
          ))}
        </div>
      )}

      {/* Done */}
      {done.length > 0 && (
        <div>
          <p className="text-xs font-medium text-gray-400 dark:text-gray-500 uppercase tracking-wider mb-2">
            Completed
          </p>
          <div className="space-y-2 opacity-75">
            {done.map((habit) => (
              <HabitCard
                key={habit.habitId}
                habit={habit}
                isCheckedIn={true}
                onCheckin={onCheckin}
                onUndo={onUndo}
              />
            ))}
          </div>
        </div>
      )}

      {totalToday === 0 && (
        <p className="text-center text-gray-400 dark:text-gray-500 py-8">
          No habits scheduled for today
        </p>
      )}
    </div>
  );
}
